export enum ContributionAmountSideKey  {
  EmployeeContributionAmount = 'employeeContributionAmount',
  EmployerContributionAmount = 'employerContributionAmount'
}

export const ContributionDateKey = 'contributionDate';